import insightActions from './insights';
import analysisActions from './analysis';

import { INSIGHT_FIELDS } from '@model';

const ACTIONS = {
  [INSIGHT_FIELDS.ANALYSIS]: {
    DELETE: analysisActions.handleDeleteInsight,
    SAVE: analysisActions.handleSaveInsight,
  },
  [INSIGHT_FIELDS.PRINCIPLE]: {
    DELETE: insightActions.handleDeletePrincipleInsight,
    SAVE: insightActions.handleSavePrincipleInsight,
  },
};

const handleInsightModalDelete =
  ({ insightId, segment, category, uuid, field, companyInstance }) =>
  async (dispatch, getState) => {
    const projectId = getState().common.currentId;
    return await dispatch(
      ACTIONS[field]?.DELETE?.({
        projectId,
        insightId,
        segment,
        category,
        uuid,
        field,
        companyInstance,
      }) || (() => ({})),
    );
  };

const handleInsightModalSave = (body) => async (dispatch, getState) => {
  const projectId = getState().common.currentId;
  const { field } = body;
  return await dispatch(
    ACTIONS[field]?.SAVE?.({ ...body, projectId }) || (() => ({})),
  );
};

export default { handleInsightModalDelete, handleInsightModalSave };
